import { useEffect, useRef } from "react";

function renderMarkdown(text) {
  let html = text
    .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
    .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
    .replace(/^[-*] (.+)$/gm, "<li>$1</li>")
    .replace(/(<li>.*<\/li>)/gs, "<ul>$1</ul>")
    .replace(/\n\n/g, "</p><p>")
    .replace(/\n/g, "<br/>");
  return `<p>${html}</p>`;
}

export const ChatMessages = ({ messages, streaming, compact }) => {
  const endRef = useRef(null);
  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  return (
    <div className={`flex flex-col gap-4 ${compact ? "" : "gap-6"}`} data-testid="chat-messages-list">
      {messages.map((m, i) => (
        <div key={i} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
          <div
            data-testid={`chat-message-${m.role}`}
            className={`${compact ? "max-w-[85%] px-4 py-2.5 text-sm" : "max-w-[75%] px-5 py-3.5"} rounded-2xl leading-relaxed ${
              m.role === "user"
                ? "bg-[#ccff00] text-black rounded-br-sm font-medium"
                : "bg-[#1a1a1a] border border-white/10 text-white/90 rounded-bl-sm"
            }`}
          >
            {m.role === "assistant" ? (
              m.content ? (
                <div className="chat-md" dangerouslySetInnerHTML={{ __html: renderMarkdown(m.content) }} />
              ) : (
                <span className="inline-flex gap-1.5 items-center py-1" aria-label="Assistant is typing">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#ccff00] animate-bounce" />
                  <span className="w-1.5 h-1.5 rounded-full bg-[#ccff00] animate-bounce [animation-delay:0.15s]" />
                  <span className="w-1.5 h-1.5 rounded-full bg-[#ccff00] animate-bounce [animation-delay:0.3s]" />
                </span>
              )
            ) : (
              m.content
            )}
          </div>
        </div>
      ))}
      <div ref={endRef} />
    </div>
  );
};

export default ChatMessages;
